export enum HomepageMonitoring {
    createGroup = 'Home_Group_Created',
    deleteGroup = 'Home_Group_Deleted',
    addPortlet = 'Home_Portles_Add',
    addTile = 'Home_Tiles_Added',
    groupsCount = 'groupsCount'
}

export enum ToDoListPromoMonitoring {
    accept = 'ToDoList_Promotion_AddHomepage',
    decline = 'ToDoList_Promotion_Dont_show_again',
    close = 'Promotion_AddHomepage_Close'
}
